import { SOCKET_INIT_SOCKET } from 'redux/actions';

export const initSocket = () => ({
  type: SOCKET_INIT_SOCKET,
});



// WEBPACK FOOTER //
// ./src/routers/actions.ts